export default {
  methods: {
    hasModule(modulo) {
      return this.$store.getters['auth/hasModule'](modulo);
    },
  },
};
